import { RelatorioStruct } from '../../structs/relatorio-interno/relatorio.struct';
export class RelatorioRequest extends RelatorioStruct {}
